import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GiBookshelf } from 'react-icons/gi';
import { HiOutlinePlusCircle } from 'react-icons/hi';
import UserBox from '../components/UserBox';

function MyLibrary() {
  const navigate = useNavigate();

  return (
    <>
      <UserBox />

      <div className="inner-container">
        <div className="inner-container__main-box">
          <div className="inner-container__cell">
            <HiOutlinePlusCircle
              className="icon__library u-margin-bottom-s"
              onClick={() => {
                navigate('/my-library/add-book');
              }}
            />
            <p className="paragraph-m paragraph-bold">Add Book</p>
          </div>

          <div className="inner-container__cell">
            <GiBookshelf
              className="icon__library u-margin-bottom-s"
              onClick={() => {
                navigate('/my-library/my-books');
              }}
            />
            <p className="paragraph-m paragraph-bold">My Books</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default MyLibrary;
